/*
 * @Author: liuxw@codoon.com
 * @Date: 2021-07-08 11:12:00
 * @Last Modified by: liuxw@codoon.com
 * @Last Modified time: 2021-07-12 14:22:51
 */

import update from "immutability-helper";
import { cloneDeep } from "lodash";
import {
  IActivityInfo,
  IGetGamblingCountData,
} from "../../service/activity/interface";
import { DEFAULT_TEMP_DETAIL } from "../../service/const";
import { IMedalInfo, IPostCreateTempDetail } from "../../service/Index";
import {
  SET_ACTIVITY_INFO_ACTION,
  SET_ACTIVITY_INFO_LOADING_ACTION,
  SET_GAMBLING_COUNT_ACTION,
  SET_MEDALS_ACTION,
  SET_TEMP_DETAIL_ACTION,
} from "./action";

export interface ICommonStore {
  activityInfo: IActivityInfo | null; // get_my_activity 接口，活动信息
  activityInfoLoading: boolean;
  gamblingCount: IGetGamblingCountData | null; // get_gambling_info接口，对赌奖金信息
  // activity_template 接口，模板详情
  tempDetail: IPostCreateTempDetail;
  medals: IMedalInfo[];
}

const INIT_COMMON_STORE: ICommonStore = {
  activityInfo: null,
  activityInfoLoading: false,
  gamblingCount: null,
  tempDetail: cloneDeep(DEFAULT_TEMP_DETAIL),
  medals: [],
};

const commonStore = (state: ICommonStore = INIT_COMMON_STORE, action: any) => {
  if (action.type === SET_ACTIVITY_INFO_ACTION) {
    return update(state, {
      activityInfo: { $set: action.data },
    });
  } else if (action.type === SET_ACTIVITY_INFO_LOADING_ACTION) {
    return update(state, {
      activityInfoLoading: { $set: action.data },
    });
  } else if (action.type === SET_GAMBLING_COUNT_ACTION) {
    return update(state, {
      gamblingCount: { $set: action.data },
    });
  } else if (action.type === SET_TEMP_DETAIL_ACTION) {
    return update(state, {
      tempDetail: { $set: action.data },
    });
  } else if (action.type === SET_MEDALS_ACTION) {
    return update(state, {
      medals: { $set: action.data },
    });
  }
  return state;
};

export default commonStore;
